import {
  ResponseType,
  CollectionsModel,
  CreateCollection,
  EditCollection,
  AddListing,
  CollectionModel,
} from '@/types';
import { apiClient } from '@/providers';
import {CollectionsGetResponse} from "@/types/responses";

export const collectionsProvider = {
  getCollections: async (): Promise<ResponseType> => {
    const response = await apiClient(`/collection/all`, 'GET');
    if (!response.ok) {
      return { ...response, data: null };
    }

    const data = response.data as CollectionsGetResponse;
    return { ...response, data };
  },

  getCollectionById: async (id: string): Promise<ResponseType> => {
    const response = await apiClient<CollectionModel>(`/collection/${id}`, 'GET');
    if (!response.ok) {
      return { ...response, data: null };
    }

    const data = response.data as CollectionModel;
    return { ...response, data };
  },

  createNewCollection: async (payload: CreateCollection): Promise<ResponseType> => {
    const response = await apiClient(`/collection`, 'POST', payload);
    if (!response.ok) {
      return { ...response, data: null };
    }

    const data = response.data as CollectionsModel;
    return { ...response, data };
  },

  addListing: async (payload: AddListing): Promise<ResponseType> => {
    const response = await apiClient(`/collection/listing`, 'POST', payload);
    if (!response.ok) {
      return { ...response, data: null };
    }

    const data = response.data;
    return { ...response, data };
  },

  updateCollection: async (payload: EditCollection): Promise<ResponseType> => {
    const response = await apiClient(`/collection/${payload.id}`, 'PATCH', payload);

    return { ...response, data: null };
  },

  deleteCollection: async (id: string): Promise<ResponseType> => {
    const response = await apiClient(`/collection/${id}`, 'DELETE');

    return { ...response, data: null };
  },

  deleteListing: async (collectionId: string, id: string): Promise<ResponseType> => {
    const response = await apiClient(`/collection/del/${collectionId}/listing/${id}`, 'DELETE');

    return { ...response, data: null };
  },
};
